function interpolateFilter(version) {
    'ngInject';

    return text => String(text).replace(/\%VERSION\%/mg, version);

}

angular
    .module('BB')
    .filter('interpolate', interpolateFilter);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/interpolate.filter.js